import type { SxProps, Theme } from '@mui/material/styles'
import { alpha } from '@mui/material/styles'
import { uiPalette } from '../../theme/uiPalette'

/** Chiều cao thanh topbar — đồng bộ KiotViet oldman (~44px). */
export const TOP_NAV_HEIGHT_PX = 44

const KIOT_LIST_UNIFIED_SURFACE_BG = '#eceff3' as const
const KIOT_SIDEBAR_RAIL_BG = '#eceff3' as const

/** Mép ngang vùng nội dung chung (BasicLayout). */
const KIOT_PAGE_MARGIN_X_PX = 16 as const
/** Độ rộng rail filter sidebar và cột đổi chi nhánh header. */
const KIOT_FILTER_SIDEBAR_WIDTH_PX = 250 as const

export const muahangKiotLike = {
  brandPrimary: uiPalette.primary.main,
  /** Thanh nav ngang KiotViet (oldman): brand `#0070f4` */
  kiotShellHeaderBg: '#0070f4',
  /**
   * Thanh POS (search + tab hóa đơn) — khác màu menu để tách tầng.
   * Đậm hơn header một bậc (gần tab active Kiot `#005ac3`).
   */
  kiotPosChromeBg: '#0057c2',
  /** Đường kẻ ngăn menu ↔ thanh POS */
  kiotPosChromeTopBorder: '1px solid rgba(0, 0, 0, 0.18)',
  /** Tab/menu đang chọn — `.kv-nav-link.active` trên KiotViet oldman: `rgb(0, 90, 195)` */
  navItemActiveBg: '#005ac3',
  navItemActiveBgHover: '#004fa8',
  /** Viền trắng nhạt cho item đang sáng / active trên header */
  navItemActiveBorder: '1px solid rgba(255, 255, 255, 0.35)',
  /** Khoảng cách giữa các nút cụm phải header */
  kiotHeaderRightItemGapPx: 5,
  /** Margin trên/dưới các nút cụm phải — header vẫn giữ chiều cao gốc */
  kiotHeaderRightItemMarginYPx: 4,
  /** Bo góc item nav (active & inactive đều 6px trên KiotViet) */
  navItemRadiusPx: 6,
  navItemActiveRadiusPx: 6,
  /** Panel menu con (flyout) — cùng tông tab active */
  kiotSubmenuPanelBg: '#0054bb',
  /** Bo góc khung menu con */
  kiotSubmenuPaperRadiusPx: 8,
  /** Bo góc từng dòng active/hover trong menu con */
  kiotSubmenuItemRadiusPx: 6,
  topNavBgHover: 'rgba(255,255,255,0.18)',
  topNavText: '#ffffff',
  topNavMuted: 'rgba(255,255,255,0.85)',
  /** `kv-btn-success` trên KiotViet (đo từ `rgb(0, 182, 62)`). */
  posButtonGreen: '#00b63e',
  posButtonGreenHover: '#019e36',
  /** Cùng tông success cho toolbar (giữ đồng bộ với POS / danh sách). */
  listToolbarGreen: '#00b63e',
  listToolbarGreenHover: '#019e36',
  kiotListUnifiedSurfaceBg: KIOT_LIST_UNIFIED_SURFACE_BG,
  kiotListToolbarStripBg: KIOT_LIST_UNIFIED_SURFACE_BG,
  pageCanvas: KIOT_LIST_UNIFIED_SURFACE_BG,
  /** Lề ngang vùng cuộn (BasicLayout); nền `AppBar` full bleed. */
  kiotPageContentMarginXPx: KIOT_PAGE_MARGIN_X_PX,
  /**
   * Padding ngang thanh header — trùng `kiotPageContentMarginXPx` để mép trái
   * ô chi nhánh thẳng với ô lọc + bảng dữ liệu.
   */
  kiotShellHeaderPaddingXPx: KIOT_PAGE_MARGIN_X_PX,
  tableBorder: '#e0e0e0',
  tableHeaderBg: '#fafafa',
  linkBlue: 'var(--muahang-primary, #0070f4)',
  filterWidth: KIOT_FILTER_SIDEBAR_WIDTH_PX,
  invoiceTableHeaderBg: `var(--muahang-invoice-thead-bg, ${uiPalette.table.headBg})`,
  invoiceSummaryRowBg: '#fff3e6',
  filterSidebarWidthPx: KIOT_FILTER_SIDEBAR_WIDTH_PX,
  /** Cột đổi chi nhánh trên header — ~2/3 độ rộng rail filter. */
  kiotHeaderBranchColumnWidthPx: Math.round((KIOT_FILTER_SIDEBAR_WIDTH_PX * 2) / 3),
  /** Khoảng cách trái menu chính sau ô chi nhánh — sát ô chọn. */
  kiotHeaderMainNavOffsetLeftPx: 0,
  /** Độ rộng hiển thị ô/cột chi nhánh trên header. */
  kiotHeaderBranchVisualWidthPx: Math.round((KIOT_FILTER_SIDEBAR_WIDTH_PX * 2) / 3),
  filterSidebarRailBg: KIOT_SIDEBAR_RAIL_BG,
  filterSidebarTitleBarBg: KIOT_SIDEBAR_RAIL_BG,
  filterSidebarCardBg: '#ffffff',
  filterSidebarCardRadiusPx: 6,
  /** Viền nhẹ quanh mỗi khối lọc sidebar (card trắng trên nền xám). */
  filterSidebarSectionBorder: '1px solid rgba(0, 0, 0, 0.08)',
  /** KiotViet card lọc không có shadow → cạnh sắc nét nhờ border 1px solid. */
  filterSidebarCardShadow: 'none',
  filterSectionDividerColor: '#eeeeee',
  listSheetBg: KIOT_LIST_UNIFIED_SURFACE_BG,
  filterPanelBorder: '#e0e0e0',
  filterPanelBorderRadiusPx: 2,
  filterSectionSummaryBg: '#ffffff',
  /** Font stack form/popup KiotViet — Roboto như màn sale Kiot. */
  kiotFontStack: 'Roboto, "Segoe UI", "Helvetica Neue", Arial, Tahoma, sans-serif',
  kiotFontSizePx: 14,
  /** Font size cho thanh menu chính (KiotViet oldman dùng cỡ ~14px lớn hơn body 13). */
  kiotNavFontSizePx: 16,
  /** Cỡ icon module trên thanh nav xanh — outlined nhỏ gọn. */
  kiotNavIconSizePx: 18,
  /** Font weight tab header / submenu — chữ đậm. */
  kiotNavFontWeight: 700,
  kiotPageTitleFontSizePx: 18,
  kiotLineHeight: 1.4,
  kiotSearchBarHeightPx: 34,
  kiotSearchBarBg: '#ffffff',
  kiotSearchBarBorder: '#d0d0d0',
  kiotSearchBarBorderHover: '#b0b0b0',
  /** Ô tìm/lọc mặc định trên toolbar — rộng vừa, không quá hẹp. */
  kiotToolbarSearchMaxWidthPx: 480,
  kiotToolbarSearchMinWidthPx: 240,
  /** Text Kiot sale: gần `#15171a` — đậm, không dùng xám nhạt cho chữ chính. */
  kiotTextPrimary: '#15171a',
  kiotTextSecondary: '#3d4654',
  kiotTextMuted: '#6b7280',
  /** Popup form thêm/sửa hàng hóa — nền trắng (KiotViet Products). */
  kiotFormSurfaceBg: '#ffffff',
  kiotFormLabelFontSizePx: 13,
  kiotFormLabelFontWeight: 500,
  /** Đậm, tương phản cao — tránh `text.secondary` MUI (#666). */
  kiotFormLabelColor: '#222222',
  kiotFormInputFontSizePx: 14,
  kiotFormInputFontWeight: 400,
  kiotFormInputColor: '#222222',
  kiotFormPlaceholderColor: '#999999',
  kiotFormInputBg: '#ffffff',
  kiotFormInputBgDisabled: '#f5f5f5',
  kiotFormInputBorder: '#dcdcdc',
  kiotFormInputBorderHover: '#c8c8c8',
  kiotFormInputBorderFocus: '#0070d2',
  kiotFormInputFocusShadow: '0 0 0 2px rgba(0, 112, 210, 0.18)',
  kiotFormInputHeightPx: 36,
  kiotFormInputRadiusPx: 8,
  kiotFormInputPaddingX: 12,
  kiotFormLabelGapPx: 0,
  /** Viền popover / menu — đồng bộ khối bảng list. */
  kiotTableOuterBorder: 'var(--muahang-table-wrapper-border, #eaedf1)',
  kiotControlRadiusPx: 2,
  kiotButtonHeightPx: 30,
  kiotListCardShadow: '0 1px 3px rgba(0, 0, 0, 0.12)',
} as const

/** Padding tab header — KiotViet `.kv-nav-link`: `7px 15px`. */
export const KIOT_HEADER_NAV_PADDING_Y = 0.875
export const KIOT_HEADER_NAV_PADDING_X = 1.875

export type KiotHeaderNavHighlightColors = {
  activeBg: string
  activeBgHover: string
}

export const getKiotHeaderNavHighlightSurfaceSx = (
  highlighted: boolean,
  colors: KiotHeaderNavHighlightColors,
): { bgcolor: string; border: string; boxSizing: 'border-box' } =>
  highlighted
    ? {
        bgcolor: colors.activeBg,
        border: muahangKiotLike.navItemActiveBorder,
        boxSizing: 'border-box',
      }
    : {
        bgcolor: 'transparent',
        border: '1px solid transparent',
        boxSizing: 'border-box',
      }

export const getKiotHeaderNavHoverBackground = (
  highlighted: boolean,
  colors: KiotHeaderNavHighlightColors,
): string => (highlighted ? colors.activeBgHover : muahangKiotLike.topNavBgHover)

export const buildKiotHeaderNavButtonSx = (
  highlighted: boolean,
  colors: KiotHeaderNavHighlightColors,
): SxProps<Theme> => {
  const radiusPx = highlighted
    ? muahangKiotLike.navItemActiveRadiusPx
    : muahangKiotLike.navItemRadiusPx
  const radius = `${radiusPx}px`
  const surface = getKiotHeaderNavHighlightSurfaceSx(highlighted, colors)
  return {
    flexShrink: 0,
    alignSelf: 'stretch',
    height: '100%',
    minHeight: TOP_NAV_HEIGHT_PX,
    textTransform: 'none',
    fontFamily: muahangKiotLike.kiotFontStack,
    fontWeight: muahangKiotLike.kiotNavFontWeight,
    fontSize: `${muahangKiotLike.kiotNavFontSizePx}px`,
    letterSpacing: '0.01em',
    lineHeight: muahangKiotLike.kiotLineHeight,
    color: muahangKiotLike.topNavText,
    borderRadius: radius,
    px: KIOT_HEADER_NAV_PADDING_X,
    py: KIOT_HEADER_NAV_PADDING_Y,
    minWidth: 'auto',
    boxShadow: 'none',
    transform: 'none',
    transition: 'background-color 120ms ease, border-color 120ms ease',
    ...surface,
    '&:hover': {
      border: surface.border,
      boxShadow: 'none',
      transform: 'none',
      bgcolor: getKiotHeaderNavHoverBackground(highlighted, colors),
      borderRadius: radius,
    },
    '&:focus': { outline: 'none', boxShadow: 'none' },
    '&:focus-visible': { outline: 'none', boxShadow: 'none' },
    '&:active': {
      border: surface.border,
      boxShadow: 'none',
      transform: 'none',
    },
  }
}

/** Icon toolbar header — luôn sáng (active), full chiều cao bar. */
export const buildKiotHeaderIconButtonSx = (
  colors: KiotHeaderNavHighlightColors,
): SxProps<Theme> => {
  const radius = `${muahangKiotLike.navItemActiveRadiusPx}px`
  const surface = getKiotHeaderNavHighlightSurfaceSx(true, colors)
  return {
    color: muahangKiotLike.topNavText,
    alignSelf: 'stretch',
    height: '100%',
    width: 40,
    minWidth: 40,
    borderRadius: radius,
    py: 0,
    boxShadow: 'none',
    transition: 'background-color 120ms ease, border-color 120ms ease',
    ...surface,
    '&:hover': {
      bgcolor: getKiotHeaderNavHoverBackground(true, colors),
      border: surface.border,
      borderRadius: radius,
    },
  }
}

const listToolbarButtonHoverMotionSx: SxProps<Theme> = {
  transition: 'background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease',
}

export const kiotListToolbarContainedButtonSx: SxProps<Theme> = {
  ...listToolbarButtonHoverMotionSx,
  textTransform: 'none',
  fontSize: `${muahangKiotLike.kiotFontSizePx}px`,
  fontFamily: muahangKiotLike.kiotFontStack,
  fontWeight: 600,
  minHeight: muahangKiotLike.kiotSearchBarHeightPx,
  height: muahangKiotLike.kiotSearchBarHeightPx,
  px: 1.5,
  py: 0,
  lineHeight: 1.25,
  boxShadow: 'none',
  boxSizing: 'border-box',
  borderRadius: `${muahangKiotLike.kiotFormInputRadiusPx}px`,
  bgcolor: 'primary.main',
  color: 'primary.contrastText',
  '&:hover': {
    bgcolor: 'primary.dark',
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    bgcolor: 'action.disabledBackground',
    color: 'action.disabled',
  },
}

/** Nút "Tạo mới" kiểu Kiot: nền trắng + viền theo `primary` (chủ đề). */
export function getKiotListToolbarPrimaryOutlineButtonSx(theme: Theme): SxProps<Theme> {
  const main = theme.palette.primary.main
  const dark = theme.palette.primary.dark
  return {
    ...listToolbarButtonHoverMotionSx,
    textTransform: 'none',
    fontSize: `${muahangKiotLike.kiotFontSizePx}px`,
    fontFamily: muahangKiotLike.kiotFontStack,
    fontWeight: 600,
    minHeight: muahangKiotLike.kiotSearchBarHeightPx,
    height: muahangKiotLike.kiotSearchBarHeightPx,
    px: 1.5,
    py: 0,
    lineHeight: 1.25,
    boxSizing: 'border-box',
    borderRadius: `${muahangKiotLike.kiotFormInputRadiusPx}px`,
    border: `1px solid ${main}`,
    bgcolor: '#ffffff',
    color: main,
    '&:hover': {
      borderColor: dark,
      bgcolor: alpha(main, 0.12),
    },
  }
}

/** Nút Xuất Excel: viền + chữ + icon theo `primary` (chủ đề). */
export function getKiotListToolbarExportOutlineButtonSx(theme: Theme): SxProps<Theme> {
  const main = theme.palette.primary.main
  const dark = theme.palette.primary.dark
  return {
    ...listToolbarButtonHoverMotionSx,
    textTransform: 'none',
    fontSize: `${muahangKiotLike.kiotFontSizePx}px`,
    fontFamily: muahangKiotLike.kiotFontStack,
    fontWeight: 600,
    minHeight: muahangKiotLike.kiotSearchBarHeightPx,
    height: muahangKiotLike.kiotSearchBarHeightPx,
    px: 1.5,
    py: 0,
    lineHeight: 1.25,
    boxSizing: 'border-box',
    borderRadius: `${muahangKiotLike.kiotFormInputRadiusPx}px`,
    border: `1px solid ${main}`,
    bgcolor: '#ffffff',
    color: main,
    '& .MuiButton-startIcon': { color: main },
    '&:hover': {
      borderColor: dark,
      bgcolor: alpha(main, 0.12),
      color: dark,
      '& .MuiButton-startIcon': { color: dark },
    },
  }
}

/** Nút xóa hàng loạt trên toolbar: viền + chữ đỏ (error). */
export function getKiotListToolbarErrorOutlineButtonSx(theme: Theme): SxProps<Theme> {
  const main = theme.palette.error.main
  const dark = theme.palette.error.dark
  return {
    ...listToolbarButtonHoverMotionSx,
    textTransform: 'none',
    fontSize: `${muahangKiotLike.kiotFontSizePx}px`,
    fontFamily: muahangKiotLike.kiotFontStack,
    fontWeight: 600,
    minHeight: muahangKiotLike.kiotSearchBarHeightPx,
    height: muahangKiotLike.kiotSearchBarHeightPx,
    px: 1.5,
    py: 0,
    lineHeight: 1.25,
    boxSizing: 'border-box',
    borderRadius: `${muahangKiotLike.kiotFormInputRadiusPx}px`,
    border: `1px solid ${main}`,
    bgcolor: '#ffffff',
    color: main,
    '& .MuiButton-startIcon': { color: main },
    '&:hover': {
      borderColor: dark,
      bgcolor: alpha(main, 0.08),
      color: dark,
      '& .MuiButton-startIcon': { color: dark },
    },
  }
}

/** Khoảng icon `startIcon` — đồng bộ Thêm / Nhập / Lọc. */
export const kiotToolbarButtonStartIconSx: SxProps<Theme> = {
  '& .MuiButton-startIcon': { mr: 0.75, ml: -0.25 },
}

/** Layout chung nút filter (màu lấy từ `color="primary"` trên Button). */
export const kiotFilterButtonLayoutSx: SxProps<Theme> = {
  textTransform: 'none',
  fontSize: `${muahangKiotLike.kiotFontSizePx}px`,
  fontFamily: muahangKiotLike.kiotFontStack,
  fontWeight: 600,
  minHeight: muahangKiotLike.kiotSearchBarHeightPx,
  height: muahangKiotLike.kiotSearchBarHeightPx,
  py: 0,
  lineHeight: 1.25,
  boxShadow: 'none',
  boxSizing: 'border-box',
  borderRadius: `${muahangKiotLike.kiotFormInputRadiusPx}px`,
  ...kiotToolbarButtonStartIconSx,
}

/** Nút «Đặt lại» — layout; màu/viền xám override ở `filterClearButtonSx`. */
export const kiotFilterClearButtonSx: SxProps<Theme> = {
  ...kiotFilterButtonLayoutSx,
  px: 1.5,
}

/** Nút «Tìm kiếm» / «Lọc» — layout; màu `primary` contained trên component. */
export const kiotFilterSearchButtonSx: SxProps<Theme> = {
  ...kiotFilterButtonLayoutSx,
  px: 2,
}

/** Nút "Import/Xuất" kiểu Kiot: nền trắng + viền xám. */
export const kiotListToolbarNeutralOutlineButtonSx: SxProps<Theme> = {
  ...listToolbarButtonHoverMotionSx,
  textTransform: 'none',
  fontSize: `${muahangKiotLike.kiotFontSizePx}px`,
  fontFamily: muahangKiotLike.kiotFontStack,
  fontWeight: 600,
  minHeight: muahangKiotLike.kiotSearchBarHeightPx,
  height: muahangKiotLike.kiotSearchBarHeightPx,
  px: 1.5,
  py: 0,
  lineHeight: 1.25,
  boxSizing: 'border-box',
  borderRadius: '8px',
  border: '1px solid #cfd5dc',
  bgcolor: '#ffffff',
  color: '#3e464f',
  '&:hover': {
    borderColor: '#a8b3bc',
    bgcolor: '#e8edf2',
  },
}
